export default [
    {
        _name: "CSidebarNavItem",
        name: "dashboard",
        to: "/app/dashboard",
        icon: "cil-speedometer",
    },
    {
        _name: "CSidebarNavDropdown",
        name: "databases",
        roles: ["ADMIN_ROLE", "USER_ROLE"],
        icon: "cil-storage",
        items: [
            {
                _name: "CSidebarNavItem",
                name: "database",
                to: "/app/database",
            },
            {
                _name: "CSidebarNavItem",
                name: "leads",
                to: "/app/leads",
            },
            {
                _name: "CSidebarNavItem",
                name: "Segments",
                roles: ["ADMIN_ROLE", "USER_ROLE"],
                to: "/app/segments",
            },
        ],
    },
    {
        _name: "CSidebarNavDropdown",
        name: "inputs",
        icon: "cil-cloud-upload",
        items: [
            {
                _name: "CSidebarNavItem",
                name: "campaings",
                to: "/app/campaings",
                roles: ["ADMIN_ROLE", "USER_ROLE", "3PARTY_CONNECTIONS_ROLE"],
            },
            {
                _name: "CSidebarNavItem",
                name: "forms",
                to: "/app/forms",
                roles: ["ADMIN_ROLE", "USER_ROLE"],
            },
            {
                _name: "CSidebarNavItem",
                name: "providers",
                to: "/app/inputs/providers",
                roles: ["ADMIN_ROLE", "USER_ROLE"],
            },
            {
                _name: "CSidebarNavItem",
                name: "imports",
                to: "/app/inputs/imports",
                roles: ["ADMIN_ROLE", "USER_ROLE"],
            },
            {
                _name: "CSidebarNavItem",
                name: "3th Party Connections",
                to: "/app/inputs/integrations",
                roles: ["ADMIN_ROLE", "USER_ROLE", "3PARTY_CONNECTIONS_ROLE"],
            },
        ],
    },
    {
        _name: "CSidebarNavDropdown",
        name: "outputs",
        icon: "outputs",
        roles: ["ADMIN_ROLE", "USER_ROLE"],
        items: [
            {
                _name: "CSidebarNavItem",
                name: "Delivery campaigns",
                to: "/app/delivery_campaings",
            },
            {
                _name: "CSidebarNavItem",
                name: "Shipment balancing",
                to: "/app/delivery-campaigns/groups",
            },
            {
                _name: "CSidebarNavItem",
                name: "clients",
                to: "/app/clients",
            },
            {
                _name: "CSidebarNavItem",
                name: "delivery_by_origins",
                to: "/app/delivery_by_origins",
            },
        ],
    },
    {
        _name: "CSidebarNavItem",
        name: "integrations",
        roles: ["ADMIN_ROLE", "USER_ROLE", "3PARTY_CONNECTIONS_ROLE"],
        to: "/app/integrations",
        icon: "cil-tags",
    },
    {
        _name: "CSidebarNavDropdown",
        name: "services",
        icon: "cil-loop-circular",
        roles: ["ADMIN_ROLE", "USER_ROLE"],
        items: [
            {
                _name: "CSidebarNavItem",
                name: "triggers",
                to: "/app/services/triggers",
            },
            {
                _name: "CSidebarNavItem",
                name: "Throlling deliveries",
                to: "/app/services/throttling-service/throttling-deliveries",
            },
        ],
    },
    {
        _name: "CSidebarNavDropdown",
        name: "Statistics",
        icon: "cil-chart",
        roles: ["ADMIN_ROLE", "USER_ROLE"],
        items: [
            {
                _name: "CSidebarNavItem",
                name: "Brevo",
                to: "/app/statistics/crm",
            },
            {
                _name: "CSidebarNavItem",
                name: "Zoho",
                to: "/app/statistics/crm-sync",
            },
            {
                _name: "CSidebarNavItem",
                name: "Logs",
                to: "/app/statistics/logs",
            },
        ],
    },
    {
        _name: "CSidebarNavItem",
        name: "creativity",
        to: "/app/creativity",
        icon: "cil-layers",
        roles: ["ADMIN_ROLE", "USER_ROLE"],
    },
    {
        _name: "CSidebarNavDropdown",
        name: "users_manager",
        icon: "cil-user",
        roles: ["ADMIN_ROLE"],
        items: [
            {
                _name: "CSidebarNavItem",
                name: "users_activity",
                to: "/app/users/activity",
            },
        ],
    },
    {
        _name: "CSidebarNavDropdown",
        name: "documentation",
        icon: "documentation",
        roles: ["ADMIN_ROLE", "USER_ROLE"],
        items: [
            {
                _name: "CSidebarNavItem",
                name: "headers",
                to: "/app/documentation/headers",
            },
        ],
    },
    {
        _name: "CSidebarNavDropdown",
        name: "Front block",
        icon: "eraser",
        roles: ["ADMIN_ROLE", "USER_ROLE"],
        items: [
            {
                _name: "CSidebarNavItem",
                name: "Emails",
                to: "/app/services/blacklist/emails",
            },
            {
                _name: "CSidebarNavItem",
                name: "Phones",
                to: "/app/services/blacklist/phones",
            },
            {
                _name: "CSidebarNavItem",
                name: "Badwords",
                to: "/app/services/blacklist/badwords",
            },
            {
                _name: "CSidebarNavItem",
                name: "Domains",
                to: "/app/services/blacklist/domains",
            },
        ],
    },
];
